module.exports = __webpack_public_path__ + "img/file.187292ba.svg";